import React from "react";
import { Icon } from "@iconify/react";
import "./home.css";

const AnimatedIcons = ({ onClick }) => (
  <div className="icon-container">
    <Icon icon="twemoji:palm-tree" className="tree-icon" onClick={onClick} />
    <Icon icon="mdi:easy-chair" className="chair-icon" onClick={onClick} />
  </div>
);

export default AnimatedIcons;
